import { TokenRedemptionOptionTypeEnum } from '@daymade/api-contracts';
import { RafflePrizeGroup } from 'components/raffle/RafflePrizeGroup';
import {
  TokenTab,
  TTokenRedemptionOptionsItem,
  TTokenRedemptionOptionsResponse,
} from 'pages/token-town';
import { useState } from 'react';
import GenericTokenRedemptionCard from './GenericTokenRedemptionCard';
import MinigameCard from './MinigameCard';

interface ITokenTownRedemptionProps {
  redemptionOptions: TTokenRedemptionOptionsResponse;
  tokenBalance: number;
  handleRedemptionSelect: (
    redemptionOption: TTokenRedemptionOptionsItem,
    prizeValue?: string
  ) => void;
  redemptionType: TokenTab;
}

export const TokenTownRedemption = ({
  redemptionOptions,
  tokenBalance,
  handleRedemptionSelect,
  redemptionType,
}: ITokenTownRedemptionProps) => {
  const [displayedRedemptionOptions, setDisplayedRedemptionOptions] =
    useState<TTokenRedemptionOptionsResponse>(redemptionOptions);

  return (
    <>
      <div className="tokenTownRedemptionOptions">
        {displayedRedemptionOptions.map((option, idx) => {
          const isDailyPound = option.code === RafflePrizeGroup.DAILY_POUND;
          const prizeValue = option.code.replace('PRIZE_', '');

          if (
            option.type === TokenRedemptionOptionTypeEnum.ENTRY &&
            option.drawDetails?.group === 'MINIGAMES'
          ) {
            return (
              <MinigameCard
                key={idx}
                redemptionOption={option}
                tokenBalance={tokenBalance}
                onClick={() =>
                  handleRedemptionSelect(
                    option,
                    redemptionType === 'games' ? prizeValue : undefined
                  )
                }
              />
            );
          }

          return (
            <GenericTokenRedemptionCard
              key={idx}
              imagePath={
                option.heroImage ||
                option.drawDetails?.prizeImageLocation ||
                undefined
              }
              redemptionCost={option.price}
              tokenBalance={tokenBalance}
              onClick={() => handleRedemptionSelect(option, prizeValue)}
            >
              <h4>{option.title}</h4>
              <p className="redemptionCardSubheading">{option.description}</p>
            </GenericTokenRedemptionCard>
          );
        })}
      </div>

      <style jsx>
        {`
          .tokenTownRedemptionOptions {
            width: 100%;
            margin: 1.5em 0;
            display: grid;
            grid-template-columns: 48% 48%;
            grid-gap: 2em 4%;
          }

          @media (min-width: 700px) {
            .tokenTownRedemptionOptions {
              grid-template-columns: 32% 32% 32%;
              grid-gap: 2em 2%;
            }

            .redemptionDescription {
              font-size: 1.25em !important;
            }
          }
        `}
      </style>
    </>
  );
};
